module.exports = __webpack_public_path__ + "static/media/placeholder.5cc0b3c8.png";